// extracted by mini-css-extract-plugin
export default {"link":"TgaR6k"};